import { SourceTypeConfigHelper } from '../../create-pipeline/components/source-settings-form/config-helper';
import {
  getSelectorInclusionStateFromRawData,
  getSelectorRawDataFromInclusionState
} from '../../../../select/factories/singleLevelSelectorFactory';

export class LinkedinAdsConfigHelper implements SourceTypeConfigHelper {
  getConfigFromRawData(rawData: any) {
    const config: any = {
      selectedAccounts: getSelectorInclusionStateFromRawData(rawData)
    };

    return config;
  }

  getDefaultConfig() {
  }

  buildConnectionParams(data: any) {
    return {
      ...getSelectorRawDataFromInclusionState(data.selectedAccounts)
    };
  }
}
